module.exports = __webpack_public_path__ + "static/media/SF-2.618a75a2.mp3";